module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sekundaerlogo_postale_innlandet_neg.a4330515.pdf";